import { TrackingDetailEvent } from "~/common/types";

export const formatAddress = (from: TrackingDetailEvent["location"]) => {
  return [from.city, from.state, from.country].filter((o) => o).join(", ");
};
